const compareFields = (fieldValue1 = '', fieldValue2 = '') => `${fieldValue1}`.localeCompare(`${fieldValue2}`)

export const sortBy = (data, field, useReverseOrder) => {
    const sorted = data.sort((row1, row2) => compareFields(row1[field], row2[field]));
    return useReverseOrder ? sorted.reverse() : sorted;
}